module.exports = __webpack_public_path__ + "img/support_hand@3x.c6fecff4.png";